import 'css-chunksrc/client/common/checkboxInput/styles.scss';export default {
  "checkboxInput": "_checkboxInput_r6g9a_1",
  "input": "_input_r6g9a_9",
  "control": "_control_r6g9a_21",
  "icon": "_icon_r6g9a_41",
  "animation-checkbox": "_animation-checkbox_r6g9a_1"
};